// CONSTS for Page
export const CANONICAL_HOMEPAGE_URL = 'https://www.nykaafashion.com';

export const DN_STORE_NAME = 'nf';
